import api from 'api'
import { License } from '../types/License'
import fetchWithToken from './fetchWithToken'

const fetchPartnerLicenses = (accountKey: string): Promise<License[]> =>
  fetchWithToken({
    baseUrl: api.partnerAdminUrl,
    path: `accounts/${accountKey}/licenses?enabledOnly=true`,
    useV5: false,
    useVersion: '',
    method: 'GET',
  })
    .then((response: Response) => response.json())
    .catch((err: Error) => console.error(err.toString()))

export default fetchPartnerLicenses
